<template>
    <a href="#" id="section1" ref="section1"></a>
    <v-card class="mt-3">
        <v-toolbar>
            <v-toolbar-title
                v-if="this.$vuetify.display.mdAndDown"
                :style="
                    this.$vuetify.display.lgAndUp ? 'max-width: 200px;' : ''
                "
            >
                Casa Verde
            </v-toolbar-title>
            <v-row
                class="ml-3"
                style="max-height: 100%; overflow: hidden"
                v-if="this.$vuetify.display.lgAndUp"
            >
                <v-col cols="12" sm="12" md="3">
                    <autocomplete-filter
                        v-model="selectedContractStatuses"
                        :items="contractStatusOptions"
                        title="Filtrează Status"
                        :is-multiple="false"
                    />
                </v-col>
                <v-col cols="12" sm="12" md="3">
                    <autocomplete-filter
                        v-model="selectedProperties"
                        :items="filterableProperties"
                        title="Filtrează după condiții speciale"
                    />
                </v-col>
                <v-col
                    v-if="
                        userPermissions.greenHouseSolarManagement
                            .canViewAllClients
                    "
                    cols="12"
                    sm="12"
                    md="3"
                >
                    <autocomplete-filter
                        v-model="selectedAgent"
                        :items="agentOptions"
                        title="Filtrează după agent"
                    />
                </v-col>
                <v-col cols="12" sm="12" md="3">
                    <autocomplete-filter
                        v-model="selectedClientNames"
                        :items="clientNameOptions"
                        title="Filtrează după nume client"
                    />
                </v-col>
            </v-row>
            <v-toolbar-items>
                <v-btn
                    color="success"
                    @click="navigateToCreateClient"
                    :disabled="
                        !userPermissions.greenHouseSolarManagement.canEditClient
                    "
                >
                    <v-icon>mdi-plus</v-icon>
                    Adaugă Client
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-row v-if="this.$vuetify.display.mdAndDown">
                <v-col cols="12" sm="12" md="3">
                    <autocomplete-filter
                        v-model="selectedContractStatuses"
                        :items="contractStatusOptions"
                        title="Filtrează Status"
                        :is-multiple="false"
                    />
                </v-col>
                <v-col cols="12" sm="12" md="3">
                    <autocomplete-filter
                        v-model="selectedProperties"
                        :items="filterableProperties"
                        title="Filtrează după condiții speciale"
                    />
                </v-col>
                <v-col
                    v-if="
                        userPermissions.greenHouseSolarManagement
                            .canViewAllClients
                    "
                    cols="12"
                    sm="12"
                    md="3"
                >
                    <autocomplete-filter
                        v-model="selectedAgent"
                        :items="agentOptions"
                        title="Filtrează dupa agent"
                    />
                </v-col>
                <v-col cols="12" sm="12" md="3">
                    <autocomplete-filter
                        v-model="selectedClientNames"
                        :items="clientNameOptions"
                        title="Filtrează după nume client"
                    />
                </v-col>
            </v-row>
            <div class="table-responsive mt-3" style="height: 80vh">
                <v-data-table
                    :headers="headers"
                    :items="filteredClients"
                    item-value="id"
                    :hover="true"
                    dense
                    class="elevation-1"
                    hide-no-data
                    fixed-header
                    height="70vh"
                    :items-per-page="-1"
                    :loading="loading"
                >
                    <template v-slot:item="{ item, index }">
                        <tr
                            @click="navigateToEditClient(item.id)"
                            style="cursor: pointer"
                        >
                            <td>{{ index + 1 }}</td>
                            <td
                                v-if="
                                    userPermissions.greenHouseSolarManagement
                                        .canViewAllClients
                                "
                            >
                                {{ item.agent_full_name || "Necunoscut" }}
                            </td>
                            <td>
                                {{ getDisplayableStatus(item) }}
                                <v-tooltip location="top" activator="parent">
                                    <span>
                                        Modificat de:
                                        {{ item.status_modified_by }}<br />
                                        Data: {{ item.status_modified_at }}
                                    </span>
                                </v-tooltip>
                            </td>
                            <td>
                                <template v-if="item.advance_invoice_paid">
                                    <v-tooltip location="top">
                                        <template #activator="{ props }">
                                            <span
                                                v-bind="props"
                                                :style="{
                                                    color: 'green',
                                                    cursor: item.advance_invoice_date
                                                        ? 'default'
                                                        : 'pointer',
                                                }"
                                                @click.stop="
                                                    !item.advance_invoice_date &&
                                                        openAdvanceInvoiceDialog(
                                                            item
                                                        )
                                                "
                                            >
                                                {{
                                                    formatAdvanceInvoiceText(
                                                        item
                                                    )
                                                }}
                                            </span>
                                        </template>
                                        <span>
                                            {{
                                                item.advance_invoice_date
                                                    ? "Data încasare avans"
                                                    : "Adaugă data încasare avans"
                                            }}
                                        </span>
                                    </v-tooltip>
                                </template>

                                <template v-else>
                                    <span>Nu</span>
                                </template>
                            </td>

                            <td>
                                <span
                                    v-if="item.latest_delivery_request"
                                    :style="{
                                        color: getDeliveryDisplay(item).color,
                                        cursor: 'pointer',
                                    }"
                                    @click.stop="handleDeliveryClick(item)"
                                >
                                    {{ getDeliveryDisplay(item).text }}
                                    <v-tooltip
                                        location="top"
                                        activator="parent"
                                    >
                                        <span>
                                            {{
                                                getDeliveryTooltipText(
                                                    getDeliveryDisplay(item)
                                                        .status,
                                                    getDeliveryDisplay(item)
                                                        .partial_delivery
                                                )
                                            }}
                                        </span>
                                    </v-tooltip>
                                </span>
                            </td>
                            <td>
                                <span
                                    :style="{
                                        color:
                                            isDeliveryOverdue(item) &&
                                            !item.delivered_goods &&
                                            !hasGoodsDeliveryAnnex(item)
                                                ? 'red'
                                                : 'inherit',
                                    }"
                                >
                                    {{
                                        item.delivered_goods ||
                                        hasGoodsDeliveryAnnex(item)
                                            ? "Da"
                                            : "Nu"
                                    }}
                                </span>
                            </td>

                            <td>{{ formatDate(item.file_approval_date) }}</td>
                            <td>{{ item.full_name }}</td>

                            <td>
                                <div class="ellipsis-text">
                                    <template v-if="item.city">
                                        {{ item.city }}</template
                                    >
                                    <template
                                        v-if="
                                            getRegionName(regions, item.region)
                                        "
                                        >,
                                        {{
                                            getRegionName(regions, item.region)
                                        }}
                                    </template>
                                </div>
                                <v-tooltip location="top" activator="parent">
                                    <span>
                                        {{ formatStreet(item.street) }}
                                        <template v-if="item.number">
                                            nr. {{ item.number }}</template
                                        >
                                        <template v-if="item.apartment"
                                            >, Ap.
                                            {{ item.apartment }}</template
                                        >
                                        <template v-if="item.city"
                                            >, {{ item.city }}</template
                                        >
                                        <template v-if="item.postal_code"
                                            >, {{ item.postal_code }}</template
                                        >
                                        <template
                                            v-if="
                                                getRegionName(
                                                    regions,
                                                    item.region
                                                )
                                            "
                                            >,
                                            {{
                                                getRegionName(
                                                    regions,
                                                    item.region
                                                )
                                            }}</template
                                        >
                                    </span>
                                </v-tooltip>
                            </td>
                            <td>{{ item.email }}</td>
                            <td>{{ item.phone }}</td>

                            <td>{{ item.panel_count }}</td>
                            <td>{{ item.panel_type }}</td>
                            <td>{{ item.panel_power }} kW</td>
                            <td>{{ item.connection }}</td>

                            <td>{{ item.inverter_type }}</td>
                            <td>{{ item.inverter_power }}</td>

                            <td>{{ item.battery_model }}</td>
                            <td>{{ item.battery_quantity }}</td>
                            <td>
                                {{ formatWithUnit(item.battery_power, "kW") }}
                            </td>
                            <td>{{ structureLabel(item.structure_type) }}</td>
                            <td>
                                {{
                                    formatWithUnit(
                                        item.contract_value_sort,
                                        "lei"
                                    )
                                }}
                            </td>
                            <td>
                                {{ formatWithUnit(item.client_discount, "%") }}
                            </td>

                            <td>
                                <v-menu transition="scale-transition" offset-y>
                                    <template #activator="{ props }">
                                        <v-btn
                                            v-bind="props"
                                            icon
                                            variant="plain"
                                            color="black"
                                        >
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <v-list-item
                                            @click.stop="openDeleteDialog(item)"
                                            v-if="
                                                userPermissions
                                                    .greenHouseSolarManagement
                                                    .canEditClient
                                            "
                                        >
                                            <v-list-item-title
                                                ><span class="text-error"
                                                    >Stergere client</span
                                                ></v-list-item-title
                                            >
                                        </v-list-item>

                                        <v-list-item
                                            v-if="
                                                item.attachments?.some(
                                                    (att) =>
                                                        att.document_type ===
                                                        'advance_invoice'
                                                )
                                            "
                                            @click.stop="requestDelivery(item)"
                                            :disabled="
                                                item.latest_delivery_request &&
                                                item.latest_delivery_request
                                                    .status !== 'approved'
                                            "
                                        >
                                            <v-list-item-title
                                                >Solicitare
                                                livrare</v-list-item-title
                                            >
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </v-card-text>

        <!-- Delete Confirmation Dialog -->
        <v-dialog v-model="isDeleteDialogVisible" max-width="500px">
            <v-card>
                <v-card-title class="headline">
                    Confirmare ștergere
                </v-card-title>
                <v-card-text>
                    Ești sigur că vrei să ștergi acest client? Această acțiune
                    nu poate fi anulată.
                </v-card-text>
                <v-card-actions class="d-flex flex-row justify-content-end">
                    <v-btn color="grey" text @click="closeDeleteDialog"
                        >Anulează</v-btn
                    >
                    <v-btn color="red" text @click="deleteClient">Șterge</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
    <DeliveryRequestDialog
        v-model="showDeliveryAlert"
        :description="deliveryDialogDescription"
        :mode="deliveryDialogMode"
        :initial-date="
            selectedDeliveryClient?.latest_delivery_request?.delivery_date
        "
        date-label="Dată trimitere"
        confirm-button-text="Confirmă"
        cancel-button-text="Închide"
        @confirm="handleDeliveryConfirm"
        @approve="approveDelivery"
        @reject-date="triggerReject"
        :delivery_description="
            selectedDeliveryClient?.latest_delivery_request?.description
        "
        :suggested_delivery_date="
            selectedDeliveryClient?.latest_delivery_request
                ?.suggested_delivery_date
        "
    />
    <v-dialog v-model="showAdvanceInvoiceDialog" max-width="500px">
        <v-card>
            <v-card-title class="headline"> Data încasării avans </v-card-title>
            <v-card-text>
                <v-text-field
                    v-model="advanceInvoiceDate"
                    type="date"
                    label="Dată factură"
                    variant="outlined"
                    hide-details
                />
            </v-card-text>
            <v-card-actions class="d-flex flex-row justify-content-end">
                <v-btn color="danger" text @click="closeAdvanceInvoiceDialog"
                    >Anulează</v-btn
                >
                <v-btn color="success" text @click="confirmAdvanceInvoiceDate"
                    >Salvează</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import apiClient from "@/utils/apiClient";
import {
    loadRegionsAndSubregions,
    getRegionName,
    showAlertModal,
    sendDeliveryEmail,
} from "@/utils/utils";
import { mapGetters, mapState } from "vuex";
import AutocompleteFilter from "@/components/common/AutocompleteFilter.vue";
import DeliveryRequestDialog from "@/components/common/DeliveryRequestDialog.vue";

export default {
    name: "GreenHouseSolarClientsList",
    components: { AutocompleteFilter, DeliveryRequestDialog },
    data() {
        return {
            showAdvanceInvoiceDialog: false,
            selectedAdvanceClient: null,
            advanceInvoiceDate: null,
            deliveryDescription: "",
            partialDeliveryText: "",
            showDeliveryAlert: false,
            selectedDeliveryClient: null,
            deliveryDialogMode: "create", // "create" sau "reevaluate"
            deliveryDateFormatted: this.initialDate
                ? new Date(this.initialDate).toLocaleDateString("ro-RO")
                : "", // pentru afișare în text field
            deliveryDate: null,
            sidebarLinks: [
                {
                    name: "Clienți Casa Verde",
                    link: "#section1",
                    id: "section1",
                },
            ],
            clients: [],
            regions: [],
            cities: [],
            isDeleteDialogVisible: false,
            clientToDelete: null,
            filterableProperties: [
                { text: "Contract Semnat", value: "__signed__" },
                { text: "Contract Nesemnat", value: "__unsigned__" },
                { text: "Act adițional semnat", value: "__act_signed__" },
                { text: "Act adițional trimis", value: "__act_sent__" },
                { text: "Act adițional netrimis", value: "__act_unsent__" },
                { text: "Are ofertă", value: "__has_offer_document__" },
                {
                    text: "Livrare parțială efectuată",
                    value: "__partial_delivery_done__",
                },
                { text: "Marfă livrată", value: "__has_delivered_goods__" },
                {
                    text: "Certificat de racordare",
                    value: "__has_connection_certificate__",
                },
            ],
            allContractStatuses: [
                { text: "Eligibil", value: "Eligibil" },
                { text: "Aprobat", value: "Aprobat" },
                { text: "Trimis", value: "Trimis" },

                {
                    text: "Avans achitat",
                    value: "Factură avans achitată",
                },
                { text: "Factură finală", value: "Factură finală" },
                { text: "Decontare depusă", value: "Decontare depusă" },
                { text: "Decontat", value: "Decontat" },
            ],
            contentTypeId: null,
            structureLabelMap: {
                tigla: "Țiglă",
                tabla_minirail: "Tablă - minirail",
                tabla_cui: "Tablă - cui adaptor",
                tabla_faltuita: "Tablă - falțuită",
                tabla_adaptor_plastic: "Tablă - cu adaptor plastic",
                sol: "Sol",
                balastare: "Balastare",
            },
            ALLOWED_STATUS_MAP: {
                eligibil: "Eligibil",
                aprobat: "Aprobat",
                trimis: "Contract trimis",
                semnat: "Contract semnat",
                nesemnat: "Contract nesemnat",
            },
            loading: false,
        };
    },
    computed: {
        ...mapGetters(["userPermissions"]),
        ...mapState({
            greenHouseSolarClientsFilters: (state) =>
                state.greenHouseSolarClientsFilters,
        }),

        selectedAgent: {
            get() {
                return this.greenHouseSolarClientsFilters.selectedAgent;
            },
            set(value) {
                this.$store.commit("setGreenHouseSolarClientsFilter", {
                    key: "selectedAgent",
                    value,
                });
            },
        },

        selectedClientNames: {
            get() {
                return this.greenHouseSolarClientsFilters.selectedClientNames;
            },
            set(value) {
                this.$store.commit("setGreenHouseSolarClientsFilter", {
                    key: "selectedClientNames",
                    value,
                });
            },
        },

        selectedContractStatuses: {
            get() {
                return this.greenHouseSolarClientsFilters
                    .selectedContractStatuses;
            },
            set(value) {
                this.$store.commit("setGreenHouseSolarClientsFilter", {
                    key: "selectedContractStatuses",
                    value,
                });
            },
        },
        selectedProperties: {
            get() {
                return this.greenHouseSolarClientsFilters.selectedProperties;
            },
            set(value) {
                this.$store.commit("setGreenHouseSolarClientsFilter", {
                    key: "selectedProperties",
                    value,
                });
            },
        },
        headers() {
            /* ---------- helper: normalise status ---------- */
            const normStatus = (raw) =>
                (raw ?? "")
                    .toLowerCase()
                    .trim()
                    .replace(/^contract\s+/i, ""); // “Contract semnat” → “semnat”

            /* ---------- column definitions ---------- */
            const base = [
                { title: "Nr. Crt.", key: "nrCrt", align: "center" },

                {
                    title: "Status",
                    key: "latest_status",
                    sort: (a, b) =>
                        normStatus(a).localeCompare(normStatus(b), "ro", {
                            sensitivity: "accent",
                        }),
                },

                {
                    title: "Avans achitat",
                    key: "advance_invoice_date_sort",
                    sort: (a, b) => {
                        if (!a || !b) return 0;
                        if (a[0] !== b[0]) return a[0] - b[0];
                        return a[1] - b[1];
                    },
                },

                {
                    title: "Dată livrare",
                    key: "delivery_date_sort",
                    sort: (a, b) => {
                        if (!a && !b) return 0;
                        if (!a) return 1;
                        if (!b) return -1;
                        return new Date(a) - new Date(b);
                    },
                },

                {
                    title: "Marfă livrată",
                    key: "goods_delivered",
                    sort: (a, b) => {
                        if (a === b) return 0;
                        return a ? -1 : 1;
                    },
                },
                { title: "Data aprobare dosar", key: "file_approval_date" },
                {
                    title: "Nume",
                    key: "full_name",
                    sort: (a, b) =>
                        (a || "").localeCompare(b || "", "ro", {
                            sensitivity: "accent",
                        }),
                },
                {
                    title: "Adresă",
                    key: "address_sort",
                    sort: (a, b) =>
                        (a || "").localeCompare(b || "", "ro", {
                            sensitivity: "accent",
                        }),
                },
                { title: "Email", key: "email" },
                { title: "Telefon", key: "phone" },
                { title: "Nr. Panouri", key: "panel_count", width: "50px" },
                { title: "Tip Panouri", key: "panel_type" },
                { title: "Putere totală Panouri", key: "panel_power" },
                { title: "Branșament", key: "connection" },
                { title: "Tip invertor", key: "inverter_type" },
                { title: "Putere invertor", key: "inverter_power" },
                { title: "Model Baterie", key: "battery_model" },
                { title: "Cantitate Baterie", key: "battery_quantity" },
                { title: "Putere totală Baterie", key: "battery_power" },
                { title: "Tip structură", key: "structure_type" },
                {
                    title: "Valoare proiect",
                    key: "contract_value_sort",
                    // numeric ascending; Vuetify will flip for descending
                    sort: (a, b) => (a || 0) - (b || 0),
                },
                { title: "Discount client", key: "client_discount" },
                { title: "Acțiuni", key: "actions", sortable: false },
            ];

            /* insert Agent column if user may view all clients */
            if (
                this.userPermissions.greenHouseSolarManagement.canViewAllClients
            ) {
                base.splice(1, 0, { title: "Agent", key: "agent" });
            }

            return base;
        },
        /**
         * Returns the appropriate delivery dialog description based on the dialog mode and client data.
         *
         * - If the mode is `"partial-approved"` and a delivery request exists, returns the partial delivery description.
         * - If the mode is `"reevaluate"`, returns a message asking the user to review the proposed delivery date.
         * - Otherwise, returns the default message requesting the user to enter a delivery date.
         *
         * @returns {string} Description text to display in the delivery dialog.
         */
        deliveryDialogDescription() {
            if (
                this.deliveryDialogMode === "partial-approved" &&
                this.selectedDeliveryClient?.latest_delivery_request
            ) {
                return this.partialDeliveryText || "Livrare parțială aprobată.";
            }
            if (
                this.deliveryDialogMode === "reevaluate" &&
                this.selectedDeliveryClient?.latest_delivery_request
            ) {
                const date =
                    this.selectedDeliveryClient.latest_delivery_request
                        .delivery_date;
                const formatted = new Date(date).toLocaleDateString("ro-RO");
                return `Vă rugăm să evaluați data propusă pentru livrare: ${formatted}`;
            }

            return "Vă rugăm introduceți data la care doriți să se trimită marfa din depozitul SISTEMA.";
        },

        /**
         * Generates unique client full names (first_name + last_name)
         * for autocomplete filtering.
         * @returns {Array<{text: string, value: string}>}
         */
        clientNameOptions() {
            return [
                ...new Map(
                    this.clients.map((client) => [
                        `${client.last_name} ${client.first_name}`,
                        {
                            text: `${client.last_name} ${client.first_name}`,
                            value: `${client.last_name} ${client.first_name}`,
                        },
                    ])
                ).values(),
            ];
        },

        /**
         * Returns a list of contract statuses for filtering.
         * Ensures that all statuses are displayed, even if no client currently has them.
         * @returns {Array<{text: string, value: string}>} Predefined list of contract statuses.
         */
        contractStatusOptions() {
            return this.allContractStatuses;
        },
        /**
         * Extracts a unique list of agents from the fetched clients.
         * - If the user has permission to view all clients, all agents are listed.
         */
        agentOptions() {
            if (
                this.userPermissions.greenHouseSolarManagement.canViewAllClients
            ) {
                return [
                    ...new Map(
                        this.clients.map((client) => [
                            client.agent_full_name, // Use full name as the key (no agent_id)
                            {
                                text: client.agent_full_name,
                                value: client.agent_full_name,
                            },
                        ])
                    ).values(),
                ];
            }
            return [];
        },

        /**
         * Filters clients based on selected contract status, agent, and client name.
         *
         * - For contract statuses with numeric logic: checks if client has reached or exceeded that status in history.
         * - For special cases:
         *    - "__has_offer_document__" — requires offer attachment
         *    - "__has_delivered_goods__" — requires delivered_goods OR document
         *
         * @returns {Array<Object>} Filtered client list.
         */
        filteredClients() {
            let clients = this.clients;

            const statusFilterActive = !!this.selectedContractStatuses;
            const selectedStatuses = this.selectedContractStatuses
                ? [this.selectedContractStatuses.toLowerCase()]
                : [];
            const propertyFilterActive = this.selectedProperties.length > 0;
            const selectedProps = this.selectedProperties;

            clients = clients.filter((client) => {
                // 1. Filter by contract status
                if (statusFilterActive) {
                    const latest = (client.latest_status || "").toLowerCase();
                    if (!selectedStatuses.includes(latest)) {
                        return false;
                    }
                }

                // 2. Filter by property flags
                if (propertyFilterActive) {
                    for (const prop of selectedProps) {
                        if (prop === "__signed__") {
                            if (!client.contract_access?.is_signed)
                                return false;
                        }

                        if (prop === "__unsigned__") {
                            const tokenExpired =
                                client.contract_access?.token_status ===
                                "expired";
                            const notSigned =
                                client.contract_access?.is_signed === false;
                            if (!(tokenExpired && notSigned)) return false;
                        }

                        if (
                            prop === "__has_offer_document__" &&
                            !client.has_offer_document
                        ) {
                            return false;
                        }
                        if (
                            prop === "__has_connection_certificate__" &&
                            !(client.attachments || []).some(
                                (att) =>
                                    att.document_type ===
                                    "connection_certificate"
                            )
                        ) {
                            return false;
                        }

                        if (
                            prop === "__has_delivered_goods__" &&
                            client.delivered_goods !== true &&
                            !(client.attachments || []).some(
                                (att) =>
                                    att.document_type === "goods_delivery_annex"
                            )
                        ) {
                            return false;
                        }
                        if (
                            prop === "__partial_delivery_done__" &&
                            !(
                                client.latest_delivery_request
                                    ?.partial_delivery === true &&
                                client.latest_delivery_request?.status ===
                                    "approved"
                            )
                        ) {
                            return false;
                        }
                        const actState = (
                            client.latest_additional_act_state || ""
                        ).toLowerCase();

                        if (prop === "__act_signed__" && actState !== "semnat")
                            return false;
                        if (prop === "__act_sent__" && actState !== "trimis")
                            return false;
                        if (
                            prop === "__act_unsent__" &&
                            actState !== "netrimis"
                        )
                            return false;
                    }
                }

                // 3. Agent filter
                if (this.selectedAgent.length > 0) {
                    if (!this.selectedAgent.includes(client.agent_full_name)) {
                        return false;
                    }
                }

                // 4. Client name filter
                if (this.selectedClientNames.length > 0) {
                    const fullName = `${client.last_name} ${client.first_name}`;
                    if (!this.selectedClientNames.includes(fullName)) {
                        return false;
                    }
                }

                return true;
            });

            return clients;
        },
    },
    async mounted() {
        try {
            const { regions, subregions } = await loadRegionsAndSubregions();
            this.regions = regions;
            this.cities = subregions;
            await this.fetchContentTypeId();
        } catch (error) {
            console.error("Error loading regions and subregions:", error);
        }
        await this.fetchClients();
        this.$store.state.sidebarLinks = this.sidebarLinks;
    },
    methods: {
        formatAdvanceInvoiceText(item) {
            if (item.advance_invoice_date) {
                const d = new Date(item.advance_invoice_date);
                return d.toLocaleDateString("ro-RO");
            }
            return "Da";
        },
        openAdvanceInvoiceDialog(item) {
            this.selectedAdvanceClient = item;
            this.advanceInvoiceDate = this.getTodayDateString();
            this.showAdvanceInvoiceDialog = true;
        },
        getTodayDateString() {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, "0");
            const dd = String(today.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
        },

        closeAdvanceInvoiceDialog() {
            this.showAdvanceInvoiceDialog = false;
            this.selectedAdvanceClient = null;
            this.advanceInvoiceDate = null;
        },

        async confirmAdvanceInvoiceDate() {
            if (!this.advanceInvoiceDate || !this.selectedAdvanceClient) return;

            try {
                await apiClient.patch(
                    `/api/greenhouse-solar-clients/${this.selectedAdvanceClient.id}/`,
                    {
                        advance_invoice_date: this.advanceInvoiceDate,
                    }
                );

                // Update in-memory list WITHOUT fetch
                const index = this.clients.findIndex(
                    (c) => c.id === this.selectedAdvanceClient.id
                );
                if (index !== -1) {
                    this.clients[index].advance_invoice_date =
                        this.advanceInvoiceDate;
                }

                this.showAdvanceInvoiceDialog = false;
                this.advanceInvoiceDate = null;
                this.selectedAdvanceClient = null;
            } catch (err) {
                console.error("Error saving advance invoice date:", err);
            }
        },
        formatWithUnit(val, unit) {
            return val || val === 0 ? `${val} ${unit}` : "";
        },
        /**
         * Returns true if the client has at least one attachment
         * whose document_type is "advance_invoice".
         */
        hasAdvanceInvoice(client) {
            return (client.attachments || []).some(
                (att) => att.document_type === "advance_invoice"
            );
        },
        structureLabel(value) {
            return this.structureLabelMap[value] || value || "";
        },
        /**
         * Fetches the content type ID from the API and assigns it to `contentTypeId`.
         * Logs an error if the request fails.
         *
         * @async
         * @returns {Promise<void>} Resolves when the content type ID is fetched and assigned.
         */
        async fetchContentTypeId() {
            try {
                const response = await apiClient.get("/api/content-types/");
                this.contentTypeId = response.data.greenhousesolarclient; // Adjust key if needed
            } catch (error) {
                console.error("Error fetching content type ID:", error);
            }
        },
        getDisplayableStatus(client) {
            const norm = (s) => (s ?? "").trim().toLowerCase();
            const allowed = this.ALLOWED_STATUS_MAP;

            /* first check the helper field we derived in fetchClients */
            const current = norm(client.latest_status);

            /* scan the whole history newest→oldest */
            let histMatch = "";
            if (Array.isArray(client.field_history)) {
                for (const h of client.field_history) {
                    const nv = norm(h.new_value);
                    const ov = norm(h.old_value);

                    /* exact map matches */
                    if (allowed[nv]) {
                        histMatch = nv;
                        break;
                    }
                    if (allowed[ov]) {
                        histMatch = ov;
                        break;
                    }

                    /* fuzzy “Semnat la …” */
                    if (nv.startsWith("semnat")) {
                        histMatch = "semnat";
                        break;
                    }
                    if (ov.startsWith("semnat")) {
                        histMatch = "semnat";
                        break;
                    }
                }
            }

            if (current.startsWith("semnat")) return allowed.semnat;
            if (histMatch.startsWith?.("semnat")) return allowed.semnat;

            if (allowed[current]) return allowed[current];
            if (allowed[histMatch]) return allowed[histMatch];

            return client.contract_status || "—";
        },
        /**
         * Checks whether the delivery date has passed and no goods have been marked as delivered.
         *
         * This is used to conditionally style the "Delivered Goods" field in red if:
         * - a delivery date exists,
         * - the date is in the past,
         * - and no delivery has been confirmed via `delivered_goods` or `goods_delivery_annex`.
         *
         * @param {Object} client - The client object containing delivery data.
         * @returns {boolean} Returns `true` if delivery is overdue and goods are not delivered; otherwise `false`.
         */
        isDeliveryOverdue(client) {
            const deliveryDate = client.latest_delivery_request?.delivery_date;
            if (!deliveryDate) return false;

            const today = new Date();
            const delivery = new Date(deliveryDate);

            // Normalize both dates to ignore time differences
            delivery.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);

            return delivery < today;
        },

        /**
         * Handles click on delivery date text.
         * - Navighează la client dacă statusul e "pending" sau "approved"
         * - Deschide dialogul de livrare doar pentru statusuri "rejected" sau "partial"
         *
         * @param {Object} item - Client object
         */
        handleDeliveryClick(item) {
            const delivery = item.latest_delivery_request;
            if (!delivery) return;

            const isPartial = delivery.partial_delivery;
            const status = delivery.status;

            if ((status === "pending" && !isPartial) || status === "approved") {
                this.navigateToEditClient(item.id);
                return;
            }

            if (status === "rejected" || isPartial) {
                this.handleDeliveryDateClick(item);
            }
        },
        /**
         * Returns the tooltip text based on delivery status and partial delivery flag.
         *
         * @param {string} status - The delivery status (e.g., 'pending', 'approved', 'rejected').
         * @param {boolean} [isPartial=false] - Flag for partial delivery (only relevant if pending).
         * @returns {string} The tooltip message for the delivery status.
         */
        getDeliveryTooltipText(status, isPartial = false) {
            if (status === "approved") return "Livrare aprobată";
            if (status === "rejected") return "Livrare respinsă";
            if (status === "pending") {
                return "În așteptare";
            }
            if (status === "pending_for_partial" && isPartial) {
                return "Livrare parțială";
            }
            return "Status necunoscut";
        },
        /**
         * Approves the delivery request by sending a PATCH request to the API with the selected delivery date.
         *
         * - Validates that all required data is available: selected client, content type ID, and delivery date.
         * - If valid, updates the delivery request status to `"approved"` via API.
         * - Displays a success or error alert depending on the outcome.
         * - Closes the delivery dialog and refreshes the client list on success.
         *
         * @async
         * @param {string} date - The delivery date to approve, in ISO format (YYYY-MM-DD).
         * @returns {Promise<void>}
         */
        async approveDelivery(date) {
            if (!this.selectedDeliveryClient || !this.contentTypeId || !date) {
                showAlertModal(
                    this.$store,
                    "Lipsesc datele necesare",
                    "danger",
                    5000
                );
                return;
            }

            const url = `/api/products-delivery-request/${this.contentTypeId}/${this.selectedDeliveryClient.id}/`;
            const payload = {
                delivery_date: date,
                status: "approved",
                suggested_delivery_date:
                    this.selectedDeliveryClient.latest_delivery_request
                        .suggested_delivery_date,
            };

            try {
                await apiClient.patch(url, payload);
                showAlertModal(
                    this.$store,
                    "Solicitarea a fost aprobată.",
                    "success",
                    5000
                );
                this.showDeliveryAlert = false;
                await this.fetchClients();
            } catch (error) {
                showAlertModal(
                    this.$store,
                    "Eroare la aprobarea livrării.",
                    "danger",
                    5000
                );
            }
            await sendDeliveryEmail({
                scenario: "agent_approved",
                client_id: this.selectedDeliveryClient.id,
                delivery_date: date,
                actor: "agent",
                description:
                    this.selectedDeliveryClient.latest_delivery_request
                        ?.description || null,
                partial_delivery:
                    this.selectedDeliveryClient.latest_delivery_request
                        ?.partial_delivery || false,
                test: false,
            });
            this.selectedDeliveryClient = null;
            this.deliveryDate = "";
        },
        /**
         * Prepares the dialog to reject or reselect a delivery date.
         *
         * - Sets the dialog mode to `"create"` (new delivery proposal).
         * - Uses `$nextTick` to ensure the dialog is reopened after state update.
         */
        triggerReject() {
            this.deliveryDialogMode = "create";
            this.$nextTick(() => {
                this.showDeliveryAlert = true; // redeschide dialogul
            });
        },

        /**
         * Handles user interaction with the delivery date for a given client.
         *
         * - If the delivery is pending and marked as partial, it fetches the shipped and scanned products,
         *   constructs a contextual description, and opens the delivery dialog in `"partial-approved"` mode.
         * - If the delivery is rejected, it sets the mode to `"reevaluate"` and opens the dialog for a new proposal.
         *
         * @async
         * @param {Object} client - The client object containing delivery information.
         * @returns {Promise<void>}
         */
        async handleDeliveryDateClick(client) {
            const delivery = client.latest_delivery_request;
            if (!delivery) return;

            this.selectedDeliveryClient = client;
            this.initialDate = delivery.delivery_date;

            // Approved & partial — use new mode

            if (
                delivery.status === "pending_for_partial" &&
                delivery.partial_delivery
            ) {
                const formattedDate = new Date(
                    delivery.delivery_date
                ).toLocaleDateString("ro-RO");

                const countText = `Livrare parțială din: ${formattedDate}`;

                this.deliveryDialogMode = "partial-approved";
                this.partialDeliveryText = countText;
                this.showDeliveryAlert = true;
            }

            // Rejected fallback
            if (delivery.status === "rejected") {
                this.deliveryDialogMode = "reevaluate";
                this.showDeliveryAlert = true;
            }
        },
        /**
         * Returns formatted delivery display data for a given client.
         *
         * - Formats the delivery date to `ro-RO` locale.
         * - Assigns a color based on the delivery status:
         *   - "pending" = black or orange (if partial)
         *   - "approved" = green
         *   - "rejected" = red
         *
         * @param {Object} client - The client object containing the latest delivery request.
         * @returns {{
         *   text: string,
         *   color: string,
         *   status: string,
         *   partial_delivery: boolean
         * } | string} An object with display data, or an empty string if no delivery exists.
         */
        getDeliveryDisplay(client) {
            const delivery = client.latest_delivery_request;
            if (!delivery?.delivery_date) return "";

            let color = "black";
            if (delivery.status === "pending_for_partial") {
                color = "orange";
            }
            if (delivery.status === "approved") {
                color = "green";
            } else if (delivery.status === "rejected") {
                color = "red";
            }

            return {
                text: new Date(delivery.delivery_date).toLocaleDateString(
                    "ro-RO"
                ),
                color,
                status: delivery.status,
                partial_delivery: delivery.partial_delivery || false,
            };
        },
        /**
         * Opens delivery dialog for the selected client.
         * @param {Object} item - The client object
         */
        requestDelivery(item) {
            this.selectedDeliveryClient = item;
            this.deliveryDialogMode = "create";
            this.showDeliveryAlert = true;
        },
        /**
         * Handles the confirmation of delivery request and sends data to backend.
         * @param {string} date - Selected ISO delivery date (YYYY-MM-DD)
         */
        async handleDeliveryConfirm(date) {
            if (!this.selectedDeliveryClient || !this.contentTypeId || !date) {
                return;
            }

            const latestRequest =
                this.selectedDeliveryClient.latest_delivery_request;
            const url = `/api/products-delivery-request/${this.contentTypeId}/${this.selectedDeliveryClient.id}/`;
            if (latestRequest && latestRequest.status !== "approved") {
                const patchPayload = {
                    delivery_date: date,
                    status: "pending",
                    partial_delivery: false,
                    suggested_delivery_date: null,
                };

                try {
                    await apiClient.patch(url, patchPayload);
                    this.showDeliveryAlert = false;
                    await this.fetchClients();
                } catch (error) {
                    console.error("Eroare la update livrare:", error);
                }
                await sendDeliveryEmail({
                    scenario: "agent_rejected",
                    client_id: this.selectedDeliveryClient.id,
                    actor: "agent",
                    delivery_date: date,
                    description:
                        this.selectedDeliveryClient.latest_delivery_request
                            ?.description || null,
                    partial_delivery:
                        this.selectedDeliveryClient.latest_delivery_request
                            ?.partial_delivery || false,
                    test: false,
                });
                this.selectedDeliveryClient = null;
                return;
            }

            // Dacă nu există nicio solicitare => POST (creăm nouă)
            if (!latestRequest || latestRequest.status === "approved") {
                const postPayload = {
                    delivery_date: date,
                    status: "pending",
                    partial_delivery: false,
                    suggested_delivery_date: null,
                };

                try {
                    await apiClient.post(url, postPayload);
                    this.showDeliveryAlert = false;
                    await this.fetchClients();
                } catch (error) {
                    console.error("Eroare la creare livrare:", error);
                }
                await sendDeliveryEmail({
                    scenario: "agent_requested",
                    client_id: this.selectedDeliveryClient.id,
                    delivery_date: date,
                    actor: "agent",
                    description:
                        this.selectedDeliveryClient.latest_delivery_request
                            ?.description || null,
                    partial_delivery:
                        this.selectedDeliveryClient.latest_delivery_request
                            ?.partial_delivery || false,
                    test: false,
                });
                this.selectedDeliveryClient = null;
            }
        },
        /**
         * Update formatted date after picking it.
         * @param {string} date - The ISO date selected (YYYY-MM-DD)
         */
        updateDeliveryDate(date) {
            this.deliveryDateFormatted = new Date(date).toLocaleDateString(
                "ro-RO"
            );
            this.deliveryMenu = false;
        },

        /**
         * Checks if the client has a "goods_delivery_annex" attachment.
         *
         * @param {Object} client - The client object.
         * @returns {boolean} True if such a document exists, false otherwise.
         */
        hasGoodsDeliveryAnnex(client) {
            return (client.attachments || []).some(
                (att) => att.document_type === "goods_delivery_annex"
            );
        },
        getRegionName,
        /**
         * Fetch GreenHouse-Solar clients and enrich each record.
         *
         * – Respects “view-all” permission (adds user_id filter when needed)
         * – Normalises legacy statuses
         * – Adds table helpers: delivery_date_sort, has_offer_document
         * – Derives:
         *     • client.latest_status          (for filters / sorting)
         *     • client.status_modified_by     (tooltip)
         *     • client.status_modified_at     (tooltip)
         *   … all from the SAME history row that introduced the label.
         */
        async fetchClients() {
            this.loading = true;
            try {
                /* ------------- API call params ------------ */
                const canViewAll =
                    this.userPermissions?.greenHouseSolarManagement
                        ?.canViewAllClients;

                const params = {};
                if (!canViewAll) {
                    params.user_id = sessionStorage.getItem("userId");
                }

                const { data } = await apiClient.get(
                    "/api/greenhouse-solar-clients/",
                    {
                        params,
                    }
                );

                /* ------------- helper fns ----------------- */
                const allowedMap = this.ALLOWED_STATUS_MAP;
                const norm = (s) => (s ?? "").trim().toLowerCase();
                const isLabelVal = (v) =>
                    !!allowedMap[norm(v)] || norm(v).startsWith("semnat");

                /* ------------- main transform ------------- */
                this.clients = data.map((client) => {
                    /* 1. legacy status rename */
                    if (client.contract_status === "Factură avans") {
                        client.contract_status = "Factură avans achitată";
                    }

                    /* 2. quick helpers */
                    client.delivery_date_sort =
                        client.latest_delivery_request?.delivery_date || null;

                    client.has_offer_document = (client.attachments || []).some(
                        (a) => a.document_type === "offer"
                    );
                    client.has_connection_certificate = (
                        client.attachments || []
                    ).some((a) => a.document_type === "connection_certificate");

                    client.advance_invoice_paid =
                        this.hasAdvanceInvoice(client);

                    client.advance_invoice_date_sort = (() => {
                        if (!client.advance_invoice_paid) {
                            // "Nu" -> cel mai mare
                            return [2, 0];
                        }
                        if (!client.advance_invoice_date) {
                            // "Da" fără dată -> după datele reale
                            return [1, 0];
                        }
                        // Dată reală -> cel mai mic
                        return [
                            0,
                            new Date(client.advance_invoice_date).getTime(),
                        ];
                    })();
                    client.goods_delivered =
                        client.delivered_goods === true ||
                        (client.attachments || []).some(
                            (att) =>
                                att.document_type === "goods_delivery_annex"
                        );

                    client.full_name = `${(client.last_name || "").trim()} ${(
                        client.first_name || ""
                    ).trim()}`.trim();

                    client.address_sort = `${(client.city || "").trim()} ${(
                        this.getRegionName(this.regions, client.region) || ""
                    ).trim()}`.toLowerCase();

                    client.contract_value_sort =
                        Number(client.contract_access?.contract_value) || 0;

                    /* 3. field_history handling */
                    const histArr = Array.isArray(client.field_history)
                        ? client.field_history
                        : client.field_history
                        ? [client.field_history] // backward compat
                        : [];

                    /* a. find the row that *set* the display label */
                    let labelRow = null;
                    let displayVal = null;

                    for (const h of histArr) {
                        if (isLabelVal(h.new_value)) {
                            // label was set here
                            labelRow = h;
                            displayVal = h.new_value;
                            break;
                        }
                        if (!labelRow && isLabelVal(h.old_value)) {
                            // remember “from” row
                            labelRow = h; // keep, but keep looping
                        }
                    }

                    /* fallback: newest row or contract_status */
                    labelRow = labelRow || histArr[0] || {};
                    displayVal =
                        displayVal ||
                        labelRow.new_value ||
                        client.contract_status;

                    /* b. attach derived fields */
                    client.latest_status = displayVal;
                    client.status_modified_by =
                        labelRow.changed_by || "Necunoscut";

                    const d = new Date(labelRow.changed_at);
                    client.status_modified_at = isNaN(d.getTime())
                        ? "Dată invalidă"
                        : d.toLocaleString("ro-RO", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                          });

                    return client;
                });
            } catch (err) {
                console.error("Error fetching clients:", err);
            }
            this.loading = false;
        },
        formatDate(date) {
            if (!date) return "";
            const d = new Date(date);
            return d.toLocaleDateString("ro-RO", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        },
        /**
         * Conditionally prepends "Str." to the street name if it doesn't start with "Strada", "Str.", or "Sat".
         *
         * @param {string} street - The name of the street to format.
         * @returns {string} - The formatted street name.
         */
        formatStreet(street) {
            if (/^(Strada|Str\.|Sat)/i.test(street)) {
                return street;
            }
            return `Str. ${street}`;
        },
        navigateToCreateClient() {
            this.$router.push({ name: "GreenHouseSolarClientCreate" });
        },
        navigateToEditClient(greenHouseClientId) {
            this.$router.push({
                name: "GreenHouseSolarClientCreate",
                params: { clientId: greenHouseClientId },
            });
        },
        openDeleteDialog(client) {
            this.clientToDelete = client;
            this.isDeleteDialogVisible = true;
        },
        closeDeleteDialog() {
            this.isDeleteDialogVisible = false;
            this.clientToDelete = null;
        },
        /**
         * Deletes the selected client from the backend and updates the local state.
         *
         * - Sends a DELETE request to the API using the selected client's ID.
         * - Removes the deleted client from the local `clients` array.
         * - Closes the delete confirmation dialog in both success and failure cases.
         *
         * @async
         * @returns {Promise<void>}
         */
        async deleteClient() {
            try {
                await apiClient.delete(
                    `/api/greenhouse-solar-clients/${this.clientToDelete.id}/`
                );
                this.clients = this.clients.filter(
                    (client) => client.id !== this.clientToDelete.id
                );
                this.closeDeleteDialog();
            } catch (error) {
                console.error("Error deleting client:", error);
                this.closeDeleteDialog();
            }
        },
    },
};
</script>

<style scoped>
/* Add any additional styling if required */
</style>
